import { FormFieldSelectNG } from '../../Form'
import {
  FormikField,
  getFormikFormFieldErrorProps,
  useFormikSelectFieldGetEmptyValue,
} from '../../Formik'
import { BuildingGroupSelect } from '../BuildingGroupSelect'

function BuildingGroupSelectFormikField({
  Select = BuildingGroupSelect,
  ...restProps
}) {
  const emptyValue = useFormikSelectFieldGetEmptyValue(restProps)

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Select={Select}
      emptyValue={emptyValue}
      getErrorProps={getFormikFormFieldErrorProps}
    />
  )
}

export default BuildingGroupSelectFormikField
